<template>
  <b-row>
    <b-col cols="12" md="12">
      <b-form-group
        :label="$lang.ticketLang.chosse_case"
        label-for="user"
        :label-cols="$config.form.labelCol"
      >
        <requiredComponent
          slot="label"
          :label="$lang.ticketLang.chosse_case"
          :rules="$v.parvandeh_selected.$params"
        />
        <selectAsync
          :options="parvandeh_options"
          v-model="$v.parvandeh_selected.$model"
          label="text"
          id="value"
          :asyncFind="getParvandehCombo"
          :isValid="
            $v.parvandeh_selected.$dirty ? !$v.parvandeh_selected.$error : null
          "
          :loading="parvandeh_loading"
          :disabled="mode === 'edit'"
        />
        <b-form-invalid-feedback
          :state="
            $v.parvandeh_selected.$dirty ? !$v.parvandeh_selected.$error : null
          "
        >
          <div v-if="!$v.parvandeh_selected.required">
            {{ $lang.error_required | replace($lang.ticketLang.chosse_case) }}
          </div>
        </b-form-invalid-feedback>
      </b-form-group>
    </b-col>

    <b-col cols="12" md="12">
      <b-alert show variant="info">
        <i class="fas fa-info-circle fa-lg mr-1" />
        <strong
          v-text="
            'در صورت عدم درج واحد بررسی درخواست، دسترسی به همه واحدها خواهد بود'
          "
        />
      </b-alert>
      <TagComponent
        category_name="ticket_unit"
        :label="$lang.ticketLang.ticket_unit"
        :multiple="true"
        :parentPermissions="parentPermissions"
        :parentValue="unit_selected"
        :requiredLabel="unitInputRequired"
        :checkValidation="unitCheckValidation"
        @updateCheckValidation="unitUpdateCheckValidation"
        @getSelected="getSelected"
      />
    </b-col>
    <b-col cols="12" md="12">
      <b-alert show variant="info">
        <i class="fas fa-info-circle fa-lg mr-1" />
        <strong
          v-text="'در صورت عدم درج وضعیت، دسترسی به همه وضعیت‌ها خواهد بود'"
        />
      </b-alert>
      <b-form-group
        :label="$lang.ticketLang.ticket_show_status"
        :label-cols="$config.form.labelCol"
      >
        <requiredComponent
          slot="label"
          :label="$lang.ticketLang.ticket_show_status"
          :rules="$v.status_selected.$params"
        />
        <selectAsync
          :options="status_options"
          v-model="$v.status_selected.$model"
          :value="status_selected"
          label="text"
          id="value"
          :multiple="true"
          placeholder="جستجو..."
          :isValid="
            $v.status_selected.$dirty ? !$v.status_selected.$error : null
          "
          :asyncFind="() => {}"
          @removeItem="removeItem"
        />

        <b-form-invalid-feedback
          :state="$v.status_selected.$dirty ? !$v.status_selected.$error : null"
        >
          <div v-if="!$v.status_selected.required">
            {{
              $lang.error_required
                | replace($lang.ticketLang.ticket_show_status)
            }}
          </div>
        </b-form-invalid-feedback>
      </b-form-group>
    </b-col>
    <b-col cols="12" md="12">
      <b-form-group>
        <requiredComponent
          slot="label"
          :label="`${$lang.ticketLang.expire_at}: `"
          :rules="$v.expire_at.$params"
        />
        <date-picker
          v-model="$v.expire_at.$model"
          type="datetime"
          :state="$v.expire_at.$dirty ? !$v.expire_at.$error : null"
          inputReq="true"
          clearable
          format="YYYY-MM-DD HH:mm:ss"
          display-format="jYYYY/jMM/jDD ساعت HH:mm"
          :class="
            $v.expire_at.$dirty
              ? $v.expire_at.$error
                ? 'invalid-date'
                : 'valid-date'
              : null
          "
        >
        </date-picker>
        <b-form-invalid-feedback
          :state="$v.expire_at.$dirty ? !$v.expire_at.$error : null"
        >
          <div v-if="!$v.expire_at.required">
            {{ $lang.error_required | replace($lang.ticketLang.expire_at) }}
          </div>
        </b-form-invalid-feedback>
      </b-form-group>
    </b-col>
    <b-col cols="12" md="12">
      <b-form-group>
        <requiredComponent
          slot="label"
          :label="`${$lang.ticketLang.description}: `"
          :rules="$v.description.$params"
        />
        <b-form-textarea
          type="text"
          v-model="$v.description.$model"
          :rows="this.$config.form.textareaRows"
        >
        </b-form-textarea>
        <b-form-invalid-feedback
          :state="$v.description.$dirty ? !$v.description.$error : null"
        >
          <div v-if="!$v.description.required">
            {{ $lang.error_required | replace($lang.ticketLang.description) }}
          </div>
        </b-form-invalid-feedback>
      </b-form-group>
    </b-col>
    <b-col cols="12" class="text-right mt-3">
      <b-button
        v-if="isAdmin(parentPermissions)"
        variant="success"
        @click="submit"
      >
        {{ $lang.submitButton }}
        <i class="fa fa-check" />
      </b-button>
      <b-button
        type="reset"
        class="ml-2"
        size="md"
        variant="danger"
        @click="close"
      >
        <i class="fa fa-ban"></i>
        {{ $lang.close }}
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import TagComponent from "@/components/tag/tagComponent.vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { required } from "vuelidate/lib/validators";
import { pathOr, includes } from "ramda";
import { isAdmin, generateApiUrl, renderEumOptions } from "@/shared/utils";

export default {
  name: "ticket-access-form",
  components: { TagComponent, datePicker: VuePersianDatetimePicker },
  props: {
    parentPermissions: {
      type: Array,
      default: () => [],
    },
    item: {
      type: Object,
      default: null,
    },
    mode: {
      type: String,
      default: "Add",
    },
  },
  validations: {
    parvandeh_selected: { required },
    status_selected: {},
    expire_at: {},
    description: {},
  },
  data() {
    return {
      loading: false,
      parvandeh_options: [],
      parvandeh_selected: null,
      parvandeh_loading: false,
      unit_selected: [],
      unitInputRequired: false,
      unitCheckValidation: false,
      status_selected: [],
      expire_at: null,
      description: null,
    };
  },
  computed: {
    status_options() {
      return renderEumOptions("ticket_status");
    },
    unit_options() {
      return renderEumOptions("ticket_unit");
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    generateApiUrl,
    renderEumOptions,
    close() {
      this.$emit("close");
    },
    getSelected(data) {
      this.unit_selected = data;
    },
    unitUpdateCheckValidation(data) {
      this.unitCheckValidation = data;
    },
    removeItem(item) {
      this.status_selected = [
        ...this.status_selected.filter((row) => row.value !== item.value),
      ];
    },
    async getParvandehCombo(query) {
      if (!query || query.length < 2) {
        return;
      }
      if (query.length > 2) {
        this.parvandeh_options = [];
      }

      try {
        this.parvandeh_loading = true;
        const url = generateApiUrl(["ticket", "user_parvandeh_combo"]);
        const queryString = {
          search_txt: query,
          type: 2,
        };
        const response = await this.$httpService.get(url, queryString);
        const data = pathOr([], ["data", "data"], response);
        this.parvandeh_options = data.map((x) => {
          return {
            text: `${pathOr("", ["parvandeh_number"], x)} - ${pathOr(
              "",
              ["person", "name"],
              x
            )} ${pathOr("", ["person", "family"], x)} - ${pathOr(
              "",
              ["person", "national_code"],
              x
            )}`,
            value: pathOr("", ["parvandeh_code"], x),
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.parvandeh_loading = false;
      }
    },
    submit() {
      this.unitCheckValidation = true;
      this.$v.$touch();
      if (this.$v.$anyError) return;
      if (this.unitInputRequired && !this.unit_selected.length) return;

      const payload = {
        ticket_unit: this.unit_selected.map((item) => item.value),
        ticket_status: this.status_selected.map((item) => item.value),
        expire_at: this.expire_at,
        description: this.description,
      };
      const parvandehCode = pathOr(null, ["value"], this.parvandeh_selected);
      this.$emit("submit", payload, parvandehCode);
    },
    fetchData() {
      if (!this.item) return;
      this.parvandeh_selected = {
        text: `${pathOr(
          "",
          ["parvandeh", "parvandeh_number"],
          this.item
        )} - ${pathOr(
          "",
          ["parvandeh", "person_full_name"],
          this.item
        )} - ${pathOr("", ["parvandeh", "national_code"], this.item)}`,
        value: pathOr("", ["parvandeh", "code"], this.item),
      };
      this.unit_selected = this.unit_options.filter((x) =>
        includes(x.value, pathOr([], ["ticket_unit"], this.item))
      );
      this.status_selected = this.status_options.filter((x) =>
        includes(x.value, pathOr([], ["ticket_status"], this.item))
      );
      this.expire_at = pathOr(null, ["expire_at", "gregorian"], this.item);
      this.description = pathOr(null, ["description"], this.item);
    },
  },
};
</script>
